var map = {
	"./กุน.jpg": 2023,
	"./ขาล.jpg": 2024,
	"./จอ.jpg": 2025,
	"./ฉลู.jpg": 2026,
	"./ชวด.jpg": 2027,
	"./มะเมีย.jpg": 2028,
	"./มะเส็ง.jpg": 2029,
	"./มะแม.jpg": 2030,
	"./มะโรง.jpg": 2031,
	"./ระกา.jpg": 2032,
	"./วอก.jpg": 2033,
	"./เถาะ.jpg": 2034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 438;